

function createRangeInputChangeHelper(range, inputFn, changeFn) {
  var inputTimer, releaseTimer, isActive;

  var destroyRelease = function () {
    clearTimeout(releaseTimer);
    range.removeEventListener('blur', releaseRange, false);
    document.removeEventListener('mouseup', releaseRange, false);
  };
  var setupRelease = function () {
    if (!isActive) {
      destroyRelease();
      isActive = true;
      range.addEventListener('blur', releaseRange, false);
      document.addEventListener('mouseup', releaseRange, true);
    }
  };
  var _releaseRange = function () {
    if (isActive) {
      destroyRelease();
      isActive = false;
      if (changeFn) {
        changeFn();
      }
    }
  };
  var releaseRange = function () {
    setTimeout(_releaseRange, 9);
  };
  var onInput = function () {
    if (inputFn) {
      clearTimeout(inputTimer);
      inputTimer = setTimeout(inputFn);
    }
    clearTimeout(releaseTimer);
    releaseTimer = setTimeout(releaseRange, 999);
    if (!isActive) {
      setupRelease();
    }
  };

  range.addEventListener('input', onInput, false);
  range.addEventListener('change', onInput, false);
}

function createSeekBar(video, seekBar) {
  var duration, videoWasPaused;
  var blockSeek = false;



  function enableDisableSeekBar() {
    duration = video.duration;
    if (duration && !isNaN(duration)) {
       seekBar.max = duration;
       seekBar.disabled = false;
    } else {
       seekBar.disabled = true;
    }
  }

  function onSeek() {
    if (!blockSeek) {
      blockSeek = true;
      videoWasPaused = video.paused;
      video.pause();
    }
    video.currentTime = seekBar.value;
  }

  function onSeekRelease() {
    if (!videoWasPaused) {
      video.play();
    }
    blockSeek = false;
  }

  function onTimeupdate() {
    if (!blockSeek) {
      //console.log('asd');
      window.requestAnimationFrame(()=> {
        seekBar.value = video.currentTime;
      })
    }
  }

  //or durationchange
  video.addEventListener('loadedmetadata', enableDisableSeekBar, false);
  video.addEventListener('emptied', enableDisableSeekBar, false);
  video.addEventListener('timeupdate', onTimeupdate, false);

  createRangeInputChangeHelper(seekBar, onSeek, onSeekRelease);

  enableDisableSeekBar();
  onTimeupdate();
}

export default createSeekBar



// WEBPACK FOOTER //
// ./public/javascripts/modules/mediaplayer-seekbar.js